import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { checkPrivileges } from "../../Helpers";
import Breadcrumb from "../common/Breadcrumb";
import Button from "../common/Button";
import Loader from "../../Layout/Loader";
import DetailTabs from "../identity/DetailTabs";
import { getUserDetailTabs } from "../identity/tabConfig";
import {
  countDevices,
  countUsers,
  deleteUpload,
  getAccountById,
  getAccountTerms,
  getLinkedDevices,
  getLinkedDeviceIds,
  getUserFiles,
  handleIdentityError,
  listAllUserIds,
} from "./usersApi";
import UpdateUserDetail from "./userDetail/Components/updateUser";
import User from "./userDetail/Components/Uses";
import Access from "./userDetail/Components/access";
import SpAccess from "./userDetail/Components/spAccess";
import Units from "./userDetail/Components/Units";
import Vehicles from "./userDetail/Components/Vehicles";
import Group from "./userDetail/Components/Group";
import Dashboard from "./userDetail/Components/Dashboard";
import Widgets from "./userDetail/Components/Widgets";
import City from "./userDetail/Components/City";
import Role from "./userDetail/Components/Roles";
import Maps from "./userDetail/Components/Maps";
import ChangedPasword from "./userDetail/Components/changedPassword";
import Reports from "./userDetail/Components/Reports";
import TermsAndConditions from "./userDetail/Components/termsAndConditions";
import UpdateThemes from "../Accounts/accountDetail/Components/updateThemes";
import { Serversettings } from "../ServerSettings/serverSettings";
import AccountUser from "../Accounts/accountDetail/Components/accountUses";
import AccountUnits from "../Accounts/accountDetail/Components/accountUnits";
import { WaslApi } from "../ServerSettings/waslApi";
import AdditionalEmails from "../Accounts/accountDetail/Components/AdditionalEmails";

const UserDetailView = (props) => {
  const dispatch = useDispatch();
  const logInUser = useSelector((state) => state.logInUsers);
  const themecolors = useSelector((state) => state.themecolors);
  const roles = useSelector((state) => state.roles);
  const cities = useSelector((state) => state.Cities?.cities);
  const devices = useSelector((state) => state.devices);
  const groups = useSelector((state) => state.groups);
  const accounts = useSelector((state) => state.accounts);
  const ServerSetting = useSelector((state) => state.ServerSetting);
  const widget = useSelector((state) => state.widgets);
  const parentUserLimits = useSelector((state) => state.parentUserLimits);
  const parentUnitLimits = useSelector((state) => state.parentUnitLimits);
  const [tab, setTab] = useState("edit");
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({
    selectedUser: props.selectItemId,
    selectedAccount: null,
    usersIds: [],
    accountAdminIds: [],
    units: [],
    loginDeviceIds: [],
    userFilesData: [],
    termsEnglish: "",
    termsArabic: "",
    termsobj: {},
    selectedUserLimits: "",
    selectedUnitsLimits: "",
    pUserLimits: parentUserLimits,
    pUnitLimits: parentUnitLimits,
  });

  const patch = (next) => setState((prev) => ({ ...prev, ...next }));

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const user = props.selectItemId;
        const [rows, account, terms, files, userLimits, unitLimits] =
          await Promise.all([
            listAllUserIds(logInUser.id),
            user?.accountId ? getAccountById(user.accountId) : null,
            user?.accountId ? getAccountTerms(user.accountId).catch(() => null) : null,
            user?.id ? getUserFiles(user.id).catch(() => []) : [],
            countUsers(user.id),
            countDevices(user.id),
          ]);
        const usersIds = (rows || []).map((row) => row.entity?.id || row.id);
        const accountAdminIds = (rows || [])
          .filter((row) => (row.entity || row).userType === 3)
          .map((row) => (row.entity || row).id);
        let units = [];
        let loginDeviceIds = [];
        if (logInUser.userType !== 6) {
          units = await getLinkedDevices(user.id).catch(() => []);
          const linked = await getLinkedDeviceIds(logInUser.id).catch(() => []);
          loginDeviceIds = (linked || []).map((item) => item.entityId || item.id);
        }
        let pUserLimits = parentUserLimits;
        let pUnitLimits = parentUnitLimits;
        if (user.parentId && parseInt(user.parentId, 10) !== parseInt(logInUser.id, 10)) {
          pUserLimits = await countUsers(user.parentId);
          pUnitLimits = await countDevices(user.parentId);
        }
        if (cancelled) return;
        patch({
          selectedUser: user,
          selectedAccount: account,
          usersIds,
          accountAdminIds,
          units: units?.data || units || [],
          loginDeviceIds,
          userFilesData: files || [],
          termsEnglish:
            terms?.data?.attributes?.termsEnglish ||
            terms?.attributes?.termsEnglish ||
            "",
          termsArabic:
            terms?.data?.attributes?.termsArabic ||
            terms?.attributes?.termsArabic ||
            "",
          termsobj: terms?.data ? terms : terms ? { data: terms } : {},
          selectedUserLimits: userLimits,
          selectedUnitsLimits: unitLimits,
          pUserLimits,
          pUnitLimits,
        });
        setLoading(false);
      } catch (error) {
        if (!cancelled) {
          toast.error(handleIdentityError(error, props.translate));
          setLoading(false);
        }
      }
    };
    if (logInUser?.id && props.selectItemId) load();
    return () => {
      cancelled = true;
    };
  }, [logInUser, props.selectItemId, parentUserLimits, parentUnitLimits, props.translate]);

  const refreshFiles = async () => {
    const files = await getUserFiles(props.selectItemId.id);
    patch({ userFilesData: files || [] });
  };

  const removeUserFile = async (mediaId) => {
    await deleteUpload(mediaId);
    refreshFiles();
  };

  const shared = {
    ...props,
    ...state,
    dispatch,
    logInUser,
    themecolors,
    roles,
    cities,
    devices,
    groups,
    accounts,
    ServerSetting,
    widget,
    parentUserLimits,
    parentUnitLimits,
    selectItemId: props.selectItemId,
    UpdateSelectedItem: (item) => patch({ selectedUser: item }),
    updateSelectedAccount: (item) => patch({ selectedAccount: item }),
    userFilesData: state.userFilesData,
    removeUserFile,
    getUserFilesData: refreshFiles,
    translate: props.translate,
  };

  const tabName = tab === "edit" ? "edit" : props.translate(tab);
  const tabs = getUserDetailTabs({
    selectedUser: state.selectedUser,
    logInUser,
  });

  if (props.spCreated || props.aaCreated) {
    const Assign = props.aaCreated ? SpAccess : Access;
    return (
      <div>
        <Breadcrumb
          itemName={props.selectItemName}
          tabName={tabName}
          onClose={props.onClose}
          moduleName={props.translate("usersDetails")}
          backLink={
            <Button size="small" onClick={props.onClose}>
              {props.translate("finish")}
            </Button>
          }
        />
        <div style={{ backgroundColor: "#fff", padding: "0 10px" }}>
          <Assign
            {...shared}
            usersIds={state.accountAdminIds}
            tableData={props.tableData}
            pagination={props.pagData}
            getMoreUsers={props.getMoreUsers}
            setPagination={props.setPagination}
            handleChangePage={props.handleChangePage}
            handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            replaceHtmlEntities={props.replaceHtmlEntities}
          />
        </div>
      </div>
    );
  }

  if (loading || !state.selectedUserLimits || !state.selectedUnitsLimits) {
    return (
      <div style={{ textAlign: "center" }}>
        <Loader defaultStyle />
      </div>
    );
  }

  return (
    <div>
      <Breadcrumb
        itemName={props.selectItemName}
        tabName={tabName}
        onClose={props.onClose}
        moduleName={props.translate("usersDetails")}
        backLink={
          <Button size="small" onClick={props.onClose}>
            {props.translate("sharedBack")}
          </Button>
        }
      />
      <DetailTabs
        value={tab}
        onChange={(event, value) => setTab(value)}
        tabs={tabs}
        translate={props.translate}
        themecolors={themecolors}
      >
        {tab === "edit" && state.selectedAccount && (
          <UpdateUserDetail {...shared} />
        )}
        {tab === "user" && (
          <User
            {...shared}
            usersIds={state.usersIds}
            tableData={props.tableData}
            pagination={props.pagData}
            getMoreUsers={props.getMoreUsers}
            setPagination={props.setPagination}
            handleChangePage={props.handleChangePage}
            handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            replaceHtmlEntities={props.replaceHtmlEntities}
          />
        )}
        {tab === "access" && (
          <Access
            {...shared}
            usersIds={state.accountAdminIds}
            tableData={props.tableData}
            pagination={props.pagData}
            getMoreUsers={props.getMoreUsers}
            setPagination={props.setPagination}
            handleChangePage={props.handleChangePage}
            handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            replaceHtmlEntities={props.replaceHtmlEntities}
          />
        )}
        {tab === "unit" && <Units {...shared} />}
        {tab === "vehicle" && (
          <Vehicles
            {...shared}
            usersIds={state.usersIds}
            tableData={props.tableData}
            pagination={props.pagData}
            getMoreUsers={props.getMoreUsers}
            setPagination={props.setPagination}
            handleChangePage={props.handleChangePage}
            handleChangeRowsPerPage={props.handleChangeRowsPerPage}
          />
        )}
        {tab === "group" && <Group {...shared} />}
        {checkPrivileges("dashboard") && tab === "dashboard" && (
          <Dashboard {...shared} />
        )}
        {tab === "city" && <City {...shared} />}
        {checkPrivileges("dashboard") && tab === "widget" && (
          <Widgets {...shared} />
        )}
        {checkPrivileges("userUpdate") && tab === "role" && <Role {...shared} />}
        {checkPrivileges("userUpdate") && tab === "map" && (
          <Maps {...props} UpdateSelectedItem={(item) => patch({ selectedUser: item })} />
        )}
        {tab === "changePassword" && <ChangedPasword {...props} logInUser={logInUser} />}
        {tab === "report" && <Reports {...props} />}
        {tab === "themeSettings" && (
          <UpdateThemes
            {...shared}
            selectedAccount={state.selectedAccount}
            UpdateSelectedItem={(item) => patch({ selectedAccount: item })}
            hasAccessOfUpdate={checkPrivileges("accountUpdate")}
          />
        )}
        {tab === "serverSettings" && (
          <Serversettings
            updateOtherServerSetting
            otherServerSetting={state.selectedAccount}
            {...props}
            selectItemId={props.selectItemId}
            updateSelectedAccount={(item) => patch({ selectedUser: item })}
            translate={props.translate}
          />
        )}
        {tab === "accountUsers" && (
          <AccountUser
            {...shared}
            selectItemId={state.selectedAccount?.id}
          />
        )}
        {tab === "accountUnits" && logInUser.userType !== 6 && (
          <AccountUnits
            {...shared}
            selectItemId={state.selectedAccount?.id}
          />
        )}
        {tab === "waslApi" && (
          <WaslApi
            {...shared}
            selectedItem={state.selectedAccount}
            UpdateSelectedItem={(item) => patch({ selectedAccount: item })}
          />
        )}
        {tab === "termsAndConditions" && (
          <TermsAndConditions
            {...shared}
            selectItemId={state.selectedUser}
            termsobj={state.termsobj}
            termsEnglish={state.termsEnglish}
            termsArabic={state.termsArabic}
            updateTermsObj={(termsobj) =>
              patch({
                termsobj,
                termsEnglish: termsobj?.data?.attributes?.termsEnglish || "",
                termsArabic: termsobj?.data?.attributes?.termsArabic || "",
              })
            }
          />
        )}
        {tab === "additionalEmails" && (
          <AdditionalEmails
            {...shared}
            isUser
          />
        )}
      </DetailTabs>
    </div>
  );
};

export default UserDetailView;
export const ViewUserDetail = UserDetailView;
